import { getGroupMembership } from "firebase-config";
import { useEffect, useState } from "react";
import { selectGroups } from "selectors/User";
import { CenterFlexColumn } from "styles/layout";
import { ErrorText } from "styles/text";
import { GroupsListItem } from "./GroupsListItem";
import { GroupsLoadingSpinner } from "./styles";
import { useAppSelector } from "app/hooks";
import { PanelList } from "components/PanelList/PanelList";

export type GroupMembership = {
  groupId: string;
  groupName: string;
  membership: string;
};

export const GroupsList = () => {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [groups, setGroups] = useState<GroupMembership[]>([]);
  const [groupsLoading, setGroupsLoading] = useState<boolean>(false);
  const groupIds = useAppSelector(selectGroups);
  useEffect(() => {
    if ((groupIds?.length ?? 0) !== 0) {
      setGroupsLoading(true);
      getGroupMembership({ groupIds: groupIds })
        .then((result) => {
          setGroups(result.data as GroupMembership[]);
        })
        .catch((error) => {
          setErrorMessage(error.message);
        })
        .finally(() => {
          setGroupsLoading(false);
        });
    }
  }, [groupIds]);

  if (groupsLoading) {
    return (
      <CenterFlexColumn>
        <GroupsLoadingSpinner />
      </CenterFlexColumn>
    );
  }

  return (
    <PanelList lastChildBorder={true}>
      {!!errorMessage && <ErrorText>{errorMessage}</ErrorText>}
      {groups.map((g) => (
        <GroupsListItem key={g.groupId} groupMembership={g} />
      ))}
    </PanelList>
  );
};
